import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';
import { SurveyItemTypes } from './SurveyItem';

/**
 * The single emptiness predicate used by required validation and section
 * completion. Keep this independent of enablement/required flags so callers
 * can apply those concerns at the appropriate tree scope.
 */
export const isRequiredValueEmpty = (
  value: any,
  itemType: SurveyItemTypes,
): boolean => {
  const emptyArray = isArray(value) && value.length === 0;
  const emptyValue = isNil(value);
  const emptyString = isString(value) && isEmpty(value);
  const emptyAttachment =
    itemType === 'attachment' && !(value as fhir.Attachment)?.url;

  return emptyArray || emptyValue || emptyString || emptyAttachment;
};
